// src/components/home/pricing/PricingSection.jsx
import { useState, useContext } from 'react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import useWindowWidth from '../../../hooks/useWindowWidth'
import GuestContext from '../../../contexts/GuestContext'

import style from './pricing.module.css'
import ArrowUpIcon from '../../../assets/svgs/ArrowUp'
import ArrowDownIcon from '../../../assets/svgs/ArrowDown'
import HatIcon from '../../../assets/svgs/Hat'
import BagIcon from '../../../assets/svgs/Bag'
import EnterpriseIcon from '../../../assets/svgs/Enterprise'

const tiers = [
  {
    key: 'Free',
    title: 'Free',
    price: '0 Kr',
    Icon: HatIcon,
    features: ['AI-powered CV feedback and match scoring for 3 jobs/month','Modular profile builder (1 sharable version)', '3 Personalized career roadmap'],
  },
  {
    key: 'Premium',
    title: 'Premium',
    price: '78 Kr',
    Icon: BagIcon,
    features: ['Unlimited AI-powered CV/job match scoring and ATS feedback','Modular profile builder (Unlimited sharable version)', 'Unlimited Personalized career roadmap'],
  },
  {
    key: 'Enterprise',
    title: 'Enterprise',
    price: 'Contact Us',
    Icon: EnterpriseIcon,
    features: [
      'Custom-branded Chimp instance with org-level analytics',
      'Internal mentoring & events',
      'Private company booths for recruitment & employer branding',
    ],
  },
]

const PricingSection = () => {
  const [expanded, setExpanded] = useState({
    Free: false,
    Premium: false,
    Enterprise: false,
  })
  const innerWidth = useWindowWidth()
  const navigate = useNavigate()
  const { setOpenGuestInfo } = useContext(GuestContext)

  const toggle = (key) => {
    setExpanded((e) => ({ ...e, [key]: !e[key] }))
  }

  const handleSelect = (key) => {
       setOpenGuestInfo(true)
       if (key === 'Enterprise') {
              // go to homepage, then scroll to the contact section
              navigate('/')
              setTimeout(() => {
                const section = document.getElementById('contact')
                if (section) {
                  section.scrollIntoView({ behavior: 'smooth' })
                }
              }, 200)
            } else {
              // Free & Premium still go to dashboard
              navigate('/dashboard/home')
              window.scrollTo({ top: 0, behavior: 'smooth' })
            }
  }

  return (
    <div className={style.mainContainer} id="pricing">
      <div className={style.container}>
        <p className={style.title}>Pricing</p>
        <div className={style.cardsContainer}>
          {tiers.map(({ key, title, price, Icon, features }) => {
            const isOpen = expanded[key]
            return (
              <div key={key} className={style.singleCard}>
                <div className={style.imageContainer}>
                  {key === 'Premium' ? (
                    <BagIcon width="55px" height="60px" color="#fff" />
                  ) : (
                    <Icon className={style.icon} />
                  )}
                </div>
                <div className={style.imageContainerMobile}>
                  {key === 'Premium' ? (
                    <BagIcon width="55px" height="60px" color="#fff" />
                  ) : (
                    <Icon className={style.icon} />
                  )}
                </div>

                <div className={style.content}>
                  {innerWidth <= 768 && (
                    <motion.div
                      className={style.plus}
                      onClick={(e) => {
                        e.stopPropagation()
                        toggle(key)
                      }}
                      initial={false}
                      animate={{ rotate: isOpen ? 0 : 180 }}
                      transition={{ duration: 0.3 }}
                    >
                      {isOpen ? (
                        <ArrowUpIcon />
                      ) : (
                        <ArrowDownIcon color="#CCD2E3" />
                      )}
                    </motion.div>
                  )}

                  <p className={style.contentTitle}>{title}</p>
                  <p className={style.price}>{price}</p>

                  {innerWidth <= 768 ? (
                    <motion.div
                      className={`${style.contentUL} ${
                        isOpen ? style.expand : ''
                      }`}
                      initial={{ height: 0 }}
                      animate={{ height: isOpen ? 'auto' : 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <ul style={{ paddingLeft: '30px' }}>
                        {features.map((f, i) => (
                          <li key={i} className={style.contentLI}>
                            {f}
                          </li>
                        ))}
                      </ul>
                      <button
                        className={style.cardButton}
                        onClick={() => {
                        // Navigate to the same page but request login popup
                        navigate('/?auth=login')
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                      }}
                      >
                        Select
                      </button>
                    </motion.div>
                  ) : (
                    <div className={style.contentUL}>
                      <ul style={{ paddingLeft: '30px' }}>
                        {features.map((f, i) => (
                          <li key={i} className={style.contentLI}>
                            {f}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {innerWidth > 768 && (
                    <button
                      className={style.button}
                      onClick={() => {
                      // Navigate to the same page but request login popup
                      navigate('/?auth=login')
                      window.scrollTo({ top: 0, behavior: 'smooth' })
                    }}
                    >
                      Select
                    </button>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default PricingSection
